<template>
  <div id="BivalentVaccineContactInfo" class="flex items-center flex-col pb-24">
    <title-w-star :title="t('bivalentVaccine.companyName')" titleColor="#603813" :starIconObj="{ componentName: 'shared', imgName: 'starIconSeaBlue', imgFormat: 'svg' }" customStyle="!mb-7" />
    <div class="text-3xl">{{ t("bivalentVaccine.address") }}</div>
    <ContactBtnGrp class="mt-10 mb-8" phoneNo="+85236283228" phoneDisplayNo="+852 3628 3228" whatsappNo="85237260622" whatsappDisplayNo="+852 3726 0622" />
    <img :src="commonStore.getImgUrl('shared', 'wechat', 'png')" class="mb-4" style="width: 3vw" />
    <img :src="commonStore.getImgUrl('shared', 'companyQRCode', 'png')" class="" style="width: 9.2vw" />
  </div>
</template>

<script setup lang="ts">
import { useBivalentVaccineStore } from "@/stores/bivalentVaccine";
import { useCommonStore } from "@/stores/common";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const bivalentVaccineStore = useBivalentVaccineStore();
const commonStore = useCommonStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>